import {ChangeDetectorRef, Component, ElementRef, Inject, OnInit} from '@angular/core';
import {DomSanitizer, SafeUrl} from '@angular/platform-browser';
import {MatSnackBar} from '@angular/material/snack-bar';
import {API_URL} from '../../../../../../core/src/lib/core/utils/tokens';
import {DeviceDetectorService} from 'ngx-device-detector';
import {HttpClient} from '@angular/common/http';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {map} from 'rxjs/operators';
import {ProjectCalcService} from '../data/project-calc.service';
import {ProposalFileInfo} from '../data/proposals-info';
import {ProjectPricing} from '../data/project-pricing';
import {ConfirmationService} from 'primeng/api';

@Component({
  selector: 'app-proposal-pdf-dialog',
  templateUrl: './proposal-pdf-dialog.component.html',
  styleUrls: ['./proposal-pdf-dialog.component.scss'],
  providers: [ConfirmationService]
})
export class ProposalPdfDialogComponent implements OnInit {
  dialogHeader: string;
  link: string;

  urlLink: string;

  showLoadingSpinner = false;

  showSendButton = true;

  blobUrl: any;

  enablePinchOnMobile: boolean;

  fullScreenStatus = false;

  pdfUrl: SafeUrl;

  discountPercent1: number;
  discountPercent2: number;
  discountPercent2Title: string;

  pricing: ProjectPricing;
  pricingId: number;

  proposals: ProposalFileInfo[] = [];
  newFileName: string;

  constructor(
    private snackBar: MatSnackBar,
    @Inject(API_URL) protected apiUrl: string,
    protected projectCalcService: ProjectCalcService,
    protected changeDetectorRef: ChangeDetectorRef,
    protected deviceDetector: DeviceDetectorService,
    protected confirmationService: ConfirmationService,
    protected el: ElementRef,
    private http: HttpClient, // TODO MOVE TO SERVICE
    protected _sanitizer: DomSanitizer,
    protected dialogRef: MatDialogRef<ProposalPdfDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private data: {
      dialogHeader: string,
      link: string,
      showSendButton: boolean;
      pricing: ProjectPricing;
    }
  ) {
    this.dialogHeader = data.dialogHeader;
    this.link = data.link;
    this.pricing = this.data.pricing
    this.pricingId = this.data.pricing.id

    if (this.pricing.discount1 > 0) {
      this.discountPercent1 = this.pricing.discount1
    }
    if (this.pricing.discount2 > 0) {
      this.discountPercent2 = this.pricing.discount2
    }

    this.discountPercent2Title = this.pricing.discount2Title


    this.showSendButton = data.showSendButton;

    this.urlLink = `${this.apiUrl}${this.link}`;

    this.pdfUrl = this._sanitizer.bypassSecurityTrustResourceUrl(this.urlLink)

    this.showLoadingSpinner = true;

    this.loadPdf()
  }

  loadPdf() {
    this.downloadFile(this.urlLink).subscribe(
      (res) => {
        this.showLoadingSpinner = false;
        this.blobUrl = res;
      }, () => {
        this.showLoadingSpinner = false;
        this.openSnackBar('Error! File not found.')
        this.dialogRef.close();
      }
    );
  }

  private downloadFile(url: string): any {
    return this.http.get(url, {responseType: 'blob'})
      .pipe(
        map((result: any) => {
          return result;
        })
      );
  }

  fullScreen() {
    this.fullScreenStatus = !this.fullScreenStatus;
    if (this.fullScreenStatus) {
      (this.el.nativeElement as HTMLElement).parentElement.parentElement.classList.add('FULLSCREEN-DIALOG')
    } else {
      (this.el.nativeElement as HTMLElement).parentElement.parentElement.classList.remove('FULLSCREEN-DIALOG')
    }
  }

  ngOnInit() {
    if (this.deviceDetector.isMobile() || this.deviceDetector.isTablet()) {
      this.enablePinchOnMobile = true;
      this.fullScreen();
    }

    this.getProposals();
  }

  getProposals() {
    this.projectCalcService.getProposals(this.pricingId).subscribe(proposals => {
      this.proposals = proposals.existingFiles
      this.newFileName = proposals.newName
    })
  }

  openSnackBar(message: string, duration = 5000) {
    this.snackBar.open(message, '', {
      duration,
      panelClass: 'error-snackbar',
      verticalPosition: 'top',
    });
  }

  openPdfInNewTab() {
    window.open(this.urlLink)
  }

  regenerate() {
    const updateInfo = {
      id: this.pricingId,
      discount1: this.discountPercent1,
      discount2: this.discountPercent2,
      discount2Title: this.discountPercent2Title
    } as ProjectPricing;

    this.showLoadingSpinner = true;

    this.projectCalcService.updatePricing(updateInfo).subscribe(() => {
      this.loadPdf()

      this.getProposals()

      this.pricing.discount1 = this.discountPercent1;
      this.pricing.discount2 = this.discountPercent2;
      this.pricing.discount2Title = this.discountPercent2Title;
    })
  }

  chooseProposalName(proposal: ProposalFileInfo, event) {
    event.stopPropagation()
    this.newFileName = proposal.name
  }

  openDropbox(proposal: ProposalFileInfo) {
    const windowReference = window.open();
    windowReference.location.assign('https://www.dropbox.com' + proposal.previewUrl);
  }

  saveProposal() {
    if (!!this.proposals.find(prop => prop.name === this.newFileName)) {
      this.confirmationService.confirm({
        header: 'Confirm File Overwrite',
        message: `A file with the name ${this.newFileName} already exists. Do you want to overwrite it?`,
        dismissableMask: true,
        accept: () => {
          this.showLoadingSpinner = true;

          this.saveProposalService()
        }
      })
    } else {
      this.showLoadingSpinner = true;
      this.saveProposalService()
    }

    // this.projectCalcService.updatePricing(updateInfo).subscribe(newProposal => {
    //   this.loadPdf()
    //
    //   this.discountPercent = null;
    //   this.getProposals()
    // })
  }

  saveProposalService() {
    this.projectCalcService.saveProposal(this.pricingId, this.newFileName).subscribe(() => {
      this.showLoadingSpinner = false;
      this.loadPdf()

      this.getProposals()
    })
  }
}
